<template>
  <agile
    v-if="slider_list.length != 0"
    ref="carousel"
    :arrows="true"
    :speed="650"
    :timing="'linear'"
    :fade="true"
    :autoplay="true"
    :pauseOnHover="false"
    :autoplaySpeed="9000"
  >
    <template v-for="slider in slider_list">
      <div
        :class="'slide slide--x'"
        v-bind:key="slider.id_slider"
        :style="'background-image: url(' + imgPreUrl + slider.url_image + '.jpg);'"
      >
        <!-- <div :class='"slide slide--x"' v-bind:key='slider.id_slider' :style='"background-image: url("+ "" + slider.url_image +"x640.jpg);"'>-->
        <template v-if="slider.style_slider.estilo_boton != 1">
          <div class="container st-contenido">
            <div :class="slider.style_slider.desc_estilo_boton">
              <h1 v-if="slider.title_slider_es != ''" class="h1-slider">
                {{ slider.title_slider_es }}
              </h1>
              <h2 v-if="slider.desc_slider_es != ''">{{ slider.desc_slider_es }}</h2>
              <a
                :href="slider.url_button_es"
                class="btn-al btn-al-lg btn-al-celeste js-scroll-trigger"
                >{{ slider.text_button_es }}</a
              >
              <template
                v-if="
                  slider.style_slider.estilo_boton == 5 ||
                    slider.style_slider.estilo_boton == 6 ||
                    slider.style_slider.estilo_boton == 7
                "
              >
                <a
                  :href="slider.url_2nd_button_es"
                  class="btn-al btn-al-lg btn-al-celeste-solid js-scroll-trigger"
                  >{{ slider.text_2nd_button_es }}</a
                >
              </template>
            </div>
          </div>
        </template>
        <a><img src="img/slider/banner-formato.gif" alt="" class="banner-formato"/></a>
      </div>
    </template>
  </agile>
</template>

<style lang="scss">
.h1-slider {
  text-transform: uppercase;
}

.dropdown .dropdown-menu {
  border-radius: 0;
}

.agile {
  position: relative;

  &__track {
  }

  &__arrow {
    height: 100%;
    top: 0;
    width: 80px;
    background-color: transparent;

    border: none;
    bottom: -11px;
    margin: 0;
    padding: 0;
    position: absolute;
    transition-duration: 0.3s;

    &:hover {
      background-color: rgba(#000, 0.5);
      #arrow-svg {
        fill: #fff;
      }
    }

    &[disabled] {
      display: none;
    }

    #arrow-svg {
      fill: rgba(#fff, 0.4);
      height: 25px;
    }

    &--prev {
      left: 0;
    }

    &--next {
      right: 0;
    }

    svg {
      fill: #888;
      height: 24px;
      transition-duration: 0.3s;
    }
  }

  &__dots {
    /*
            align-items: center;
            display: flex;
            justify-content: center;
            list-style: none;
            margin: 20px 0;
            padding: 0;
            text-align: center;
            white-space: nowrap;
            */
    bottom: 5%;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
  }

  &__dot {
    button {
      opacity: 0.2;
      background-color: transparent;
      border: 1px solid #fff;
      border-radius: 50%;
      cursor: pointer;
      display: block;
      height: 14px;
      margin: 10px;

      &:hover {
        background-color: #fff;
      }
    }

    &--current {
      button {
        background-color: #fff;
      }
    }
  }

  .slide {
    background: {
      position: center;
      size: cover;
    }

    height: auto !important;

    &:before {
      background-color: rgba(#000, 0.2);
      content: '';
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }
}
</style>

<script>
import { config_settings } from '../../config.js';
import axios from 'axios';

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const INTERNAL_SERVER_ERROR = 500;
const CONFLICT = 409;

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.message === 'Network Error') {
      toastr.error(
        'No se puede conectar con el servidor. Verifique su conexión a internet',
        'ERROR',
        { iconClass: 'customer-danger' }
      );
    } else if (error.response.status === UNAUTHORIZED) {
      if (error.response.data.message === 'Access is denied') {
        toastr.error('Usted no tiene los provilegios para acceder a esta sección', 'ERROR', {
          iconClass: 'customer-danger',
        });
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }
);

export default {
  props: ['sliderlist'],
  data() {
    return {
      slider_list: [],
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
    };
  },
  methods: {
    obtener_sliders() {
      axios
        .get(config_settings.RESOURCE_SERVER_URL + '/GET/sliders')
        .then(response => {
          this.slider_list = response.data;
        })
        .catch(error => {});
    },
  },
  created() {
    this.obtener_sliders();
  },
};
</script>
